module.exports = __webpack_public_path__ + "assets/img/center_icon13.ce7d8f78.svg";